module.exports = __webpack_public_path__ + "dist/fonts/roboto/Roboto-MediumItalic-webfont.ttf";


//////////////////
// WEBPACK FOOTER
// ./dist/fonts/roboto/Roboto-MediumItalic-webfont.ttf
// module id = 1638
// module chunks = 0